import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface ReturnBorrowCollection {
  id: number
  collectionNo: string
  displayTitle: string
  interlibraryLoanCode: SystemCode
  borrowingDate: string
  borrowingDueDate: string
}

export function ReturnBorrowCollectionFromJSON(
  json: any
): ReturnBorrowCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    interlibraryLoanCode: exists(json, 'interlibrary_loan_code')
      ? SystemCodeFromJSON(json.interlibrary_loan_code)
      : defaultSystemCode(),
    borrowingDate: exists(json, 'borrowing_date')
      ? dateToPlainFormat(json.borrowing_date)
      : '',
    borrowingDueDate: exists(json, 'borrowing_due_date')
      ? dateToPlainFormat(json.borrowing_due_date)
      : ''
  }
}
